export class AreaPitecoModel {
  public type_user: any[] = [];
  public belonging_office: any[] = [];
  public notes: string;
}
